module.exports = __webpack_public_path__ + "img/06-0愿景.c8d25e6d.svg";